export default "__VITE_ASSET__CR$bVc9n__"